<template>
  <div class="page-wrapper">
    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="6">
          <Select v-model="searchData.areaFid"  placeholder="区域名称" filterable>
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in areaListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <!--<Col span="3">-->
          <!--<Select v-model="searchData.feedbackName" placeholder="反馈来源">-->
            <!--<Option value=''>请选择</Option>-->
            <!--<Option v-for="(item,index) in monthList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
          <!--</Select>-->
        <!--</Col>-->
        <!--<Col span="6">-->
          <!--<DatePicker style="width:100%" v-model="searchData.createTime" format="yyyy-MM-dd" split-panels type="daterange" placeholder="创建日期筛选"></DatePicker>-->
        <!--</Col>-->
        <Col span="5">
          <Input placeholder="区域编号" v-model="searchData.areaCode"></Input>
        </Col>
        <Col span="5">
        <Select v-model="searchData.areaType" placeholder="区域类型">
        <Option value=''>请选择</Option>
        <Option v-for="(item,index) in areaTypeList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
        </Col>
      </Row>
    </search-group>

    <div >
      <Button  type="primary" @click.stop="add" class="mb16">新增</Button>
    </div>

    <droiw-marker
        :n="addN"
        :pid="pid"
        @done="getData"
    ></droiw-marker>

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>

  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import droiwMarker from "@/views/gdMap/droiwMarker";
  import TableList from 'components/TableList/index';
  import {getArealist} from "../../api/area";
  import {getAreas} from "api/common";

  export default {
    condition:'advice',
    components: {
      SearchGroup,
      TableList,
      droiwMarker
    },
    mounted() {
      this.findData()
    },
    computed: {
      searchDataComputed() {
        return {
          areaFid:this.searchData.areaFid,
          areaCode: this.searchData.areaCode,
          areaType:this.searchData.areaType
        }
      }
    },
    watch: {
    },
    data() {
      return {
        infoN:0,
        itemData:null,
        // projectListData:[],
        monthList:[],
        searchParams:null,
        data: [],
        addN:0,
        addM:0,
        areaListData:[],
        areaTypeList:[],
        pid:'',
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center',
          },
          {
            title: ' '
          },
          {
            title: '区域编号 ',
            key: 'areaCode',
            width: 180,
          },

          {
            title: ' '
          },
          {
            title: "区域名称",
            key: 'areaName',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: '区域类型',
            key: 'areaTypeName',
            width: 130,

          },
          {
            title: ' '
          },
          {
            title: "所属组织机构",
            key: 'orgName',
            width: 180,
            // render:(h,params)=>{
            //   return h('span',{},formatMoney(params.row['commissionPersonal']))
            // }
          },
          {
            title: ' '
          },
            {
            title: "区域详细地址",
            key: 'address',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: '操作',
            align: 'center',
            width: 150,
            fixed: 'right',
            render:(h,params)=>{
              return [
                h('a', {
                  on: {
                    click: () => {
                      this.$nextTick( ()=> {
                        this.pid=params.row.fid;
                        this.addN++;

                      })
                    }
                  },
                  style: {
                    marginRight: '10px'
                  }
                }, '编辑信息')
              ]
            }
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          areaFid: '',
          areaCode:'',
          areaType:''
        },
      }
    },
    methods: {
      add(){
        this.pid='';
        this.addN++
      },
      getAreasList(){
        getAreas().then(res => {
          if (!res.data) {
            return
          }
          this.areaListData = res.data.areaNameList;
          this.areaTypeList = res.data.areaTypeList;
        }).catch(() => {
          return
        })
      },
      getData(){
        const params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
          getArealist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]
        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          areaFid: '',
          areaCode:''
        }
      },
      changeTableRowTextExpandState(i){
        this.data = this.data.map(( item,index ) => {
          if( i === index ){
            item.expandText = !item.expandText
          }
          return item;
        })
      }
    },
    created() {
      this.getAreasList()
    }
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .wrappertabs{
    min-height: 400px;
  }
</style>
<style>
  .feedback-text-wrapper{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .feedback-text-container > .ivu-table-cell > div{
    padding: 10px 0;
    overflow: hidden;
  }
</style>